<!-- Bar search -->
<ng-container *ngIf="appearance === 'bar'">
    <button
        mat-icon-button
        *ngIf="!opened"
        (click)="open()">
        <mat-icon [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
    </button>
    <div
        class="absolute inset-0 flex items-center shrink-0 z-99 bg-card"
        *ngIf="opened"
        @slideInTop
        @slideOutTop>
        <mat-icon
            class="absolute ml-6 sm:ml-8"
            [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
        <input
            class="w-full h-full px-16 sm:px-18 search-input-placeholder"
            [formControl]="searchControl"
            [matAutocomplete]="matAutocomplete"
            [placeholder]="'Search Files/Documents/Drive'"
            (keydown)="onKeydown($event)"
            #barSearchInput>
        <mat-autocomplete
            class="max-h-128 sm:px-2 border-t rounded-b shadow-md"
            [autoSelectActiveOption]="true"
            [disableRipple]="true"
            #matAutocomplete="matAutocomplete">
            <mat-option
                class="py-0 px-6 text-md pointer-events-none text-secondary bg-transparent"
                *ngIf="resultSets && !resultSets.length">
                No results
            </mat-option>
            <ng-container *ngFor="let resultSet of resultSets; trackBy: trackByFn">
                <mat-optgroup class="flex items-center mt-2 px-2">
                    <span class="text-sm font-semibold tracking-wider text-secondary">{{resultSet.label.toUpperCase()}}</span>
                </mat-optgroup>
                <ng-container *ngFor="let result of resultSet.results; trackBy: trackByFn">
                    <mat-option
                        class="group relative mb-1 py-0 px-6 text-md rounded-md hover:bg-gray-100 dark:hover:bg-hover"
                        [routerLink]="result.link"
                        [value]="result.value">
                        <!-- Contacts -->
                        <ng-container *ngIf="resultSet.id === 'contacts'">
                            <ng-container *ngTemplateOutlet="contactResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                        <!-- Pages -->
                        <ng-container *ngIf="resultSet.id === 'pages'">
                            <ng-container *ngTemplateOutlet="pageResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                        <!-- Tasks -->
                        <ng-container *ngIf="resultSet.id === 'tasks'">
                            <ng-container *ngTemplateOutlet="taskResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                    </mat-option>
                </ng-container>
            </ng-container>
        </mat-autocomplete>
        <button
            class="absolute top-1/2 right-5 sm:right-7 shrink-0 w-10 h-10 -mt-5"
            mat-icon-button
            (click)="close()">
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>
</ng-container>

<!-- Basic search -->
<ng-container *ngIf="appearance === 'basic'">
    <div class="w-full sm:min-w-80">
        <mat-form-field
            class="w-full"
            [subscriptSizing]="'dynamic'">
            <mat-icon
                matPrefix
                [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
            <input
                matInput
                [formControl]="searchControl"
                [matAutocomplete]="matAutocomplete"
                [matAutocompleteDisabled]="config.emitKeywords"
                [placeholder]="config.placeholder"
                [(ngModel)]="inputValue"
                (keydown)="onKeydown($event)">
                <span matSuffix style="display: inline-flex; gap: 4px; align-items: center;">
                    <mat-progress-spinner *ngIf="loading" [diameter]="20" [mode]="'indeterminate'"></mat-progress-spinner>
                    <button *ngIf="inputValue"
                        mat-icon-button matTooltip="Clear" (click)="clearSearchPanel()">
                      <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Advanced Search" (click)="openAdvancedSearchPanel($event)" #advancedSearchOrigin>
                      <mat-icon [svgIcon]="'heroicons_outline:adjustments-horizontal'"></mat-icon>
                    </button>
                </span>
        </mat-form-field>
        <mat-autocomplete
            class="max-h-128 mt-1 rounded"
            [autoSelectActiveOption]="true"
            [disableRipple]="true"
            #matAutocomplete="matAutocomplete">
            <mat-option
                class="py-0 px-6 text-md pointer-events-none text-secondary bg-transparent"
                *ngIf="assets && !assets.length&&!isLoading">
                No results
            </mat-option>
            <mat-option
                class="py-0 px-6 text-md pointer-events-none text-secondary bg-transparent"
                *ngIf="isLoading ">
            Searching
            </mat-option>
            <div class="search-result-list">
                <ng-container *ngFor="let asset of assets; let i = index; trackBy: trackByFn">
                    <mat-option 
                        class="search-result-option relative py-0 px-6 text-md rounded-md hover:bg-gray-100 dark:hover:bg-hover"
                        (onSelectionChange)="navigateToFolder(asset)">
                        <!-- Record Rows - Folders -->
                        <div *ngIf="asset.type === 'FOLDER'" class="flex items-center  flex-grow">
    
                            <div class="col-8 flex justify-center items-center gap-1  ">
                                <div class="file-icon relative flex flex-0 items-center justify-center ml-1 mr-1">
                                    <mat-icon class="icon-size-6 opacity-80 text-yellow-400" [svgIcon]="utils.getFileTypeImage('folder')"></mat-icon>
                                </div>
                                <div matTooltip="{{asset.name}}" [routerLink]="['/apps/file-manager/folders/', asset.id]">
                                    <!-- DO NOT TRUNCATE THE FILENAME -->
                                    <div class="flex flex-col">
                                        <span class="font-semibold leading-tight"> {{asset?.name}}</span>
                                        <span class="font-light text-xs font-small text-gray-400 leading-tight"> {{asset?.parent?.name}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-2 flex justify-center items-center absolute right-4">
                                <div class="row flex ">
                                    <mat-icon  [routerLink]="['/apps/file-manager/folders/', asset.id]" class="icon-size-4" svgIcon="feather:link"></mat-icon>
                                </div>
                            </div>
                        </div>
                
                        <!-- Record Rows - Files -->
                        <div *ngIf="asset.type === 'FILE'" 
                            class="flex items-center custom-wrapper">
                            <div [routerLink]="['/apps/file-manager/folders/', asset.parent.id]" class="flex search-result-link">
                                <div class="flex justify-center items-center">
                                    <div class="file-icon mr-4">
                                        <mat-icon class="file-icon-size" [svgIcon]="utils.getFileTypeImage(asset.extension)"></mat-icon>
                                    </div>
                                    <div class="flex flex-col mr-2">
                                        <span class="font-semibold leading-tight"> {{asset?.name}}</span>
                                        <span class="font-light leading-tight text-sm font-small text-gray-400"> {{asset?.parent?.name}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="flex mr-2 search-result-download">
                                <button mat-icon-button matTooltip="Download"
                                    (click)="download(asset)">
                                    <mat-icon class="icon-size-4 mr-0" svgIcon="feather:download"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </mat-option>
                </ng-container>
                <div>
                </div>
                <div *ngIf="assets.length<totalSearchResults&&assets.length" class="w-full flex justify-center py-2" 
                [ngClass]="{'hidden': moreLoading}"> <button  (click)="searchMoreAssets()" class="btn text-primary cursor-pointer ">Load more</button>
                    
                </div>
                <div *ngIf="moreLoading" class="w-full flex justify-center py-2"> 
                    <button [disabled]="true"  class="btn text-primary cursor-pointer ">Loading more</button>
                </div>
            </div>
           
        </mat-autocomplete>
    </div>
</ng-container>

<!-- Advanced Search panel -->
<ng-template #advancedSearchPanel>
    <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-2xl overflow-hidden shadow-lg">
        <div class="sm:hidden -ml-1 mr-3">
            <button
                mat-icon-button
                (click)="closeAdvancedSearchPanel()">
                <mat-icon
                    class="icon-size-5 text-current"
                    [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
            </button>
        </div>
      <!--TODO - add child widget for advanced search (see theme example)-->
        <form class="flex flex-col mt-2 p-8 pb-4 bg-card rounded-2xl shadow overflow-hidden"
            [formGroup]="advancedSearchForm">

            <div class="flex">
                <mat-form-field
                    class="flex-auto">
                    <mat-label>File Name</mat-label>
                    <input
                    id="keywords"
                    matInput
                    [formControlName]="'keywords'"
                   [(ngModel)]="assetsSearch.keywords"
                    >
                    <mat-error
                    *ngIf="
                        advancedSearchForm.get('keywords').hasError('required')
                    "
                >
                    File name is required
                </mat-error>
                </mat-form-field>
            </div>
        
            <!-- Labels -->
            <div class="flex">
                <!-- Tags / Labels -->
                <mat-form-field class="label-chip-list">
                    <mat-label>Labels</mat-label>
                    <div class="vertical-layout">
                        <mat-chip-grid #chipGrid aria-label="Label selection">
                            <ng-container *ngFor="let tag of tags" >
                                <mat-chip-row  (removed)="remove(tag)" *ngIf="(tag.name=='Any'&&tags.length>1)?false:true">
                                    {{ tag.name ||tag}}
                                    <button *ngIf="(tag.name=='Any'&&tags.length==1)?false:true" matChipRemove [attr.aria-label]="'remove ' + (tag.name || tag)">
                                    <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:x-circle'"></mat-icon>
                                    </button>
                                </mat-chip-row>
                            </ng-container>

                            </mat-chip-grid>
                            <input
                                #tagInput
                                placeholder="Label..."
                                [formControl]="tagCtrl"
                                [matChipInputFor]="chipGrid" [matAutocomplete]="auto"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                (matChipInputTokenEnd)="add($event)"
                                class="label-chip-input"/>
                    </div>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                        <!-- TYPEERROR tag.name -->
                        <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">{{ tag.name }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <!--
            <div class="flex">
                <mat-form-field
                    class="flex-auto">
                    <mat-label>Keywords</mat-label>
                    <input
                    id="keywords"
                    matInput
                    [formControlName]="'keywords'"
                    >
                    <mat-hint></mat-hint>
                </mat-form-field>
            </div>
            -->
             <!-- File Type -->
             <div class="flex">
                <mat-form-field class="w-full"> 
                    <mat-label>File Type</mat-label>
                    <!-- <mat-icon style="margin-left: 4px;" [svgIcon]="(advancedSearchForm.get('type').value=='any')?'dms-custom:doc':advancedSearchForm.get('type').value.icon
                    "></mat-icon> -->
                    <mat-select 
                    id="fileType"
                    name="fileType"
                    [formControlName]="'fileType'"
                    matInput
                    >
                    <mat-option [value]="'any'" >
                      <mat-icon [svgIcon]="'heroicons_outline:document-check'"></mat-icon>
                       Any
                      </mat-option>
                        <ng-container *ngFor="let fileType of (fileTypes)">
                            <mat-option [value]="fileType.type">
                              <mat-icon [svgIcon]="utils.getFileTypeImage(fileType.icon)"></mat-icon>
                              {{ fileType.label }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
              <!-- Date Modified -->
              <div class="flex">
                <mat-form-field class="w-full"> 
                    <mat-label>Date Modified</mat-label>
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_outline:clock'"
                        matPrefix></mat-icon>
                    <mat-select
                    [(ngModel)]="dataRange"
                    id="dataRange"
                    (ngModelChange)="onDateRangeChange($event)"
                    matInput
                    [formControlName]="'dataRange'"
                    >  <mat-option [value]="'any'">
                       All
                      </mat-option>
                        <mat-option *ngFor="let item of dateRanges" [value]="item.value">{{item.label}}</mat-option>
                    </mat-select>
                </mat-form-field>
             
            </div>
                <div *ngIf="dataRange == 'customDate'"
                class="flex  mt-2 flex-col">
                    <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-full" appearance="fill">
                        <mat-label class="font-medium text-gray-900 dark:text-gray-100">Start Date</mat-label>
                        <input [formControlName]="'startDate'" matInput [matDatepicker]="startDatePicker" [(ngModel)]="assetsSearch.start"
                           >
                        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #startDatePicker></mat-datepicker>
                        <mat-error
                        *ngIf="
                            advancedSearchForm.get('startDate').hasError('required')
                        "
                    >
                        Start Date is required
                    </mat-error>
                    </mat-form-field>
                    <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-full" appearance="fill">
                        <mat-label class="font-medium text-gray-900 dark:text-gray-100">End Date</mat-label>
                        <input [formControlName]="'endDate'"  matInput [matDatepicker]="endDatePicker" [(ngModel)]="assetsSearch.end"
                           >
                        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                        <mat-error
                        *ngIf="
                            advancedSearchForm.get('endDate').hasError('required')
                        "
                    >
                        End Date is required
                    </mat-error>
                    </mat-form-field>
            </div>
            <div class="flex flex-col items-start -ml-2">
                <!-- In trash -->
                <mat-checkbox
                    *ngIf="config.showTrashFilter"
                    (change)="onTrashToggle($event)"
                    [color]="'primary'"
                    [formControlName]="'TRASHED'"
                    >
                    In trash
                </mat-checkbox>

                <!-- Archived -->
                <!--
                <mat-checkbox
                    [color]="'primary'"
                    [formControlName]="'isArchived'">
                    Archived
                </mat-checkbox>
                -->

                <!-- Starred -->
                <mat-checkbox
                    (change)="onStarToggle($event)"
                    [color]="'primary'"
                    [formControlName]="'isFavourite'"
                    >
                    Is Favorite (Starred)
                </mat-checkbox>
            </div>
            <!-- Divider -->
            <div class="mt-4 mb-4 border-t"></div>

            <!-- Actions -->
            <div class="flex items-center justify-end">
                <button
                    class="ml-4"
                    mat-button
                    type="button"
                    [color]="'accent'" 
                    (click)="reset()">Reset
                </button>
                <button
                    class="ml-4"
                    mat-stroked-button
                    type="submit"
                    [color]="'primary'"
                    (click)="advancedSearch()">Search
                </button>
            </div>
            <!-- <mat-error *ngIf="advancedSearchForm?.errors?.fileOrTag">please enter required fields</mat-error> -->
        </form>
    </div>
</ng-template>


<!-- Contact result template -->
<ng-template
    #contactResult
    let-result>
    <div class="flex items-center">
        <div class="flex shrink-0 items-center justify-center w-8 h-8 rounded-full overflow-hidden bg-primary-100 dark:bg-primary-800">
            <img
                *ngIf="result.avatar"
                [src]="result.avatar">
            <mat-icon
                class="m-0 icon-size-5 text-primary dark:text-primary-400"
                *ngIf="!result.avatar"
                [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        </div>
        <div class="ml-3 truncate">
            <span [innerHTML]="result.name"></span>
        </div>
    </div>
</ng-template>

<!-- Page result template -->
<ng-template
    #pageResult
    let-result>
    <div class="flex flex-col">
        <div
            class="truncate leading-normal"
            [innerHTML]="result.title"></div>
        <div class="truncate leading-normal text-sm text-secondary">
            {{result.link}}
        </div>
    </div>
</ng-template>

<!-- Task result template -->
<ng-template
    #taskResult
    let-result>
    <div class="flex items-center">
        <ng-container *ngIf="result.completed">
            <mat-icon
                class="mr-0 text-primary dark:text-primary-400"
                [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
        </ng-container>
        <ng-container *ngIf="!result.completed">
            <mat-icon
                class="mr-0 text-hint"
                [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
        </ng-container>
        <div
            class="ml-3 truncate leading-normal"
            [ngClass]="{'line-through text-hint': result.completed}"
            [innerHTML]="result.title"></div>
    </div>
</ng-template>
